module.exports = __webpack_public_path__ + "static/media/most-active-month-video.5a7d8bbd.mp4";